import React, {Fragment} from 'react';
import { Form, Field } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {search as search_function} from './google_search_logic';
import axios from 'axios';

export default function newSearch(props){
  function onSubmit(params){
    let query=[params.queries[0].query];
    console.log(query);
    search_function(query, response_function);
  }

  function response_function(response){
    console.log(response);
  }

  return(
    <Form
    {...props}
    onSubmit={onSubmit}
    mutators={{
      ...arrayMutators
    }}
    >
      {props => (
        <form onSubmit={props.handleSubmit} style={{width:'100%', marginBottom:'40px'}}>
        <Grid container style={{width:'100%'}}>
        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
            <Grid container style={{maxWidth:'350px', width:'100%', marginTop:'40px'}}>
              <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center', width:'90%'}}><Field name='name'>{(f)=><TextField label='Name' value={f.input.value} onChange={f.input.onChange}/>}</Field></Grid>
              <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center', width:'90%'}}><Field name='max_results'>{(f)=><TextField label='Maximum results' value={f.input.value} onChange={f.input.onChange}/>}</Field></Grid>
            </Grid>
        </Grid>
        <Grid item xs={12}>
        <FieldArray name='queries'>
        {({ fields }) =>
        <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px'}}>
        <div style={{width:'350px'}}>
        <Grid container style={{marginTop:'20px'}}>
          <Grid item xs={12}><Typography style={{width:'100%', textAlign:'center', marginBottom:'15px', color:'rgb(0, 116, 225)'}}>{"Queries"}</Typography></Grid>
          <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button type="button" variant='outlined' color='primary' onClick={() => {if(fields.length!=5){fields.push({}, undefined)}}} style={{marginRight:'10px'}}>{"Add query"}</Button></Grid>
          <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button type="button" variant='outlined' color='primary' onClick={() => fields.pop()} style={{marginRight:'10px'}}>{"Remove query"}</Button></Grid>
        </Grid>
          {fields.map((name, index) => (
              <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', width:'350px', marginTop:'10px'}}><Field name={`${name}.query`}>{(f)=><TextField label='Query' name='query' value={f.input.value} onChange={f.input.onChange} style={{width:'100%'}} required />}</Field></div>
        ))}
        </div>
        </div>
      }
        </FieldArray>
        </Grid>
        </Grid>
        <button type='submit' style={{display:'none'}} ref={(e)=>{props.submit_button_ref.current=e}}/>
        </form>
      )}
    </Form>
  )
}
